'use strict';

var _slicedToArray = require("/vercel/workpath0/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/vercel/workpath0/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/workpath0/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

var download =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(url, name) {
    var a;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            a = document.createElement('a');
            a.download = name;
            a.href = url;
            a.style.display = 'none';
            document.body.append(a);
            a.click(); // Chrome requires the timeout

            _context.next = 8;
            return delay(100);

          case 8:
            a.remove();

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function download(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

module.exports =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(urls) {
    var options,
        _iteratorNormalCompletion,
        _didIteratorError,
        _iteratorError,
        _iterator,
        _step,
        _ref5,
        _ref4,
        index,
        url,
        name,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

            if (urls) {
              _context2.next = 3;
              break;
            }

            throw new Error('`urls` required');

          case 3:
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context2.prev = 6;
            _iterator = urls.entries()[Symbol.iterator]();

          case 8:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context2.next = 20;
              break;
            }

            _ref5 = _step.value;
            _ref4 = _slicedToArray(_ref5, 2);
            index = _ref4[0];
            url = _ref4[1];
            name = typeof options.rename === 'function' ? options.rename({
              url: url,
              index: index,
              urls: urls
            }) : '';
            _context2.next = 16;
            return delay(index * 1000);

          case 16:
            download(url, name);

          case 17:
            _iteratorNormalCompletion = true;
            _context2.next = 8;
            break;

          case 20:
            _context2.next = 26;
            break;

          case 22:
            _context2.prev = 22;
            _context2.t0 = _context2["catch"](6);
            _didIteratorError = true;
            _iteratorError = _context2.t0;

          case 26:
            _context2.prev = 26;
            _context2.prev = 27;

            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }

          case 29:
            _context2.prev = 29;

            if (!_didIteratorError) {
              _context2.next = 32;
              break;
            }

            throw _iteratorError;

          case 32:
            return _context2.finish(29);

          case 33:
            return _context2.finish(26);

          case 34:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[6, 22, 26, 34], [27,, 29, 33]]);
  }));

  return function (_x3) {
    return _ref2.apply(this, arguments);
  };
}();